var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{attrs:{"outlined":"","required":"","dense":"","placeholder":"+994 50 765 43 21","name":_vm.name,"label":_vm.label,"value":_vm.value,"hide-details":"","rules":_vm.rules},model:{value:(_vm.phone),callback:function ($$v) {_vm.phone=$$v},expression:"phone"}})
}
var staticRenderFns = []

export { render, staticRenderFns }